import { gql } from '@apollo/client'

export const GET_SEATS_TEMPLATE = gql`
  query GetSeatsTemplate($tripId: ID!, $segmentId: ID!) {
    seatsTemplate(input: { tripID: $tripId, segmentID: $segmentId }) {
      vehicleTemplate {
        id
        name
        type
        layout {
          component
          properties
          label
          isEmpty @client
        }
        capacity
        vehicleIDs
        companies {
          id
          name
        }
      }
      seats {
        id
        label
        status
      }
    }
  }
`
